import { render } from "./HomeView.vue?vue&type=template&id=03a0f652&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/fyh/Desktop/Luckytu-Project/Luckytu_Interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__